import { parseLocaleNumber } from '@witmetrics/utils/numbers';
import { formatNumber, isBlank } from '@witmetrics/utils/strings';
import { theme } from '@/utils/theme';
import type { NumberInputValue } from '@/components/inputs/NumberInput/types';

export const classes = {
  incrementInput: 'pr-0',
  incrementWrapper: 'flex flex-col items-center',
  incrementButton:
    'hover:bg-grey-2 transition-colors px-2 border-l border-b border-grey-4 h-5 place-center dark:hover:bg-white/[0.06] dark:border-white/10',
  incrementIcon: 'text-base',
};

export const styles = {
  incrementInput: {
    borderRadius: '18px 12px 12px 18px',
    overflow: 'hidden',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette['orange-2'].main,
    },
  },
  incrementWrapper: {
    '& button:last-of-type': {
      borderBottom: 'none',
    },
  },
};

export function getValue(
  newValue: string,
  currentValue: NumberInputValue,
  min?: number,
  max?: number
): NumberInputValue {
  const label = cleanValue(newValue);
  const value = parseLocaleNumber(newValue);
  if (isBlank(label) || label === '-') return { label, value };
  if (isNaN(value)) return currentValue;
  if (min !== undefined && value < min)
    return { label: formatNumber(min), value: min };
  if (max !== undefined && value > max)
    return { label: formatNumber(max), value: max };
  return { label, value };
}

function cleanValue(value: string) {
  // Remove any invalid characters from the number string
  return value.replace(/[^0-9.,\-]+/g, '');
}

export function incrementValue(
  { label, value }: NumberInputValue,
  increment: number,
  min?: number,
  max?: number
): NumberInputValue {
  // Value should be received as a locale-formatted string
  let newValue = value;
  if (isBlank(label) || newValue === null || isNaN(newValue)) {
    newValue = 0; // Default to 0 if value can't otherwise be determined
  }
  newValue += increment;
  if (min !== undefined && newValue < min) {
    newValue = min;
  } else if (max !== undefined && newValue > max) {
    newValue = max;
  }
  return { label: formatNumber(newValue), value: newValue };
}
